<div class="modal-header vlv-modal-header">
  <div class="vlv-header-icon">
    <i class="fa-solid fa-book-open"></i>
  </div>
  <div class="vlv-header-body">
    <div class="vlv-header-title" translate>Vocabulaire</div>
    <div class="vlv-header-sub">{{ level?.name }}</div>
  </div>
  <button type="button" class="vlv-close-btn" (click)="close()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<div class="modal-body vlv-modal-body">

  <app-spinner *ngIf="loader"></app-spinner>

  <ng-container *ngIf="!loader">

    <div class="vlv-count-label">
      <i class="fa-solid fa-layer-group"></i>
      {{ words.length }} <span translate>mots</span>
    </div>

    <div class="vlv-list">
      <app-vocabulary-item
        *ngFor="let word of words; trackBy: trackById"
        [word]="word"
        [supPinyin]="supPinyin"
        [langSrcName]="langSrcSrv.current.name"
        [langTgtName]="langTgtSrv.current.name"
        [langTgtCode]="langTgtSrv.current.code"
        [displayPhonetic]="langTgtSrv.current.displayPhonetic">
      </app-vocabulary-item>
    </div>

  </ng-container>

</div>
